const BASE_URL = '/'
const AUTH = BASE_URL
const AUTH_AUTO = '/auto-login'
const HOME = '/home'
const REPORTS = `${BASE_URL}reports`
const REPORTS_GENERAL = `${REPORTS}/general`
const REPORTS_MONTHLY = `${REPORTS}/monthly`
const UNAUTHORIZED = '/unauthorized'
const GROUPS_DETAIL = '/groups/:uuid'

export default {
  BASE_URL,
  AUTH,
  HOME,
  REPORTS,
  REPORTS_GENERAL,
  REPORTS_MONTHLY,
  UNAUTHORIZED,
  GROUPS_DETAIL,
}
